import React from "react";

interface RichContentProps {
  html: string;
  className?: string;
}

const RichContent: React.FC<RichContentProps> = ({ html, className = "" }) => {
  return (
    <div
      className={`rich-content overflow-x-auto ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RichContent;
